const SERVICE_TYPE = {
  beusable: 1
}

export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const SERVICE_CODE = SERVICE_TYPE[process.env.VUE_APP_SERVICE_NAME] || SERVICE_TYPE.beusable
export const HTTP_STATUS = {
  badRequest: 400,
  unauthrized: 401,
  unprocessableEntity: 422
}

export const HTTP_HEADER_SKIP_ERROR = 'Dream-Skip-Error'
export const STORAGE_ITEM = {
  authToken: 'authToken'
}

export const AUTH_COOKIE = {
  name: 'dream_auth',
  value: '1',
  expires: 365,
  path: '/'
}

export const UI_TYPE_COOKIE = {
  name: 'ui_type',
  expires: 365,
  path: '/'
}

if (IS_PRODUCTION) {
  AUTH_COOKIE.domain = '.beusable.net'
  UI_TYPE_COOKIE.domain = '.beusable.net'
}

export const CDN_HOST = 'https://dream-cdn.beusable.net'
export const DOCUMENT_TITLE_PREFIX = 'Beusable'
export const OLD_BEUSABLE_HOST = IS_PRODUCTION ? 'https://www.beusable.net' : 'http://localhost:3000'

export const UTM_TAGS = ['source', 'medium', 'campaign', 'term', 'content']
export const CID_TAGS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
export const CHANNEL_TAGS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17']
export const NEW_MOBILE_HEATMAP_STARTDATE = '2021-07-01'
